import React from 'react';
import OwnerLayout from '@components/Layouts/OwnerLayout';

/** Keeps sidebar + shell mounted while only the page content swaps. */
export function withOwnerLayout(page) {
	return <OwnerLayout>{page}</OwnerLayout>;
}
